const tabItems = document.querySelectorAll('[js-tab-item]');
const tabContents = document.querySelectorAll('[js-tab-content]');

let swipers = [];

tabItems.forEach(item => {
  item.addEventListener('click', (e) => {
    e.preventDefault();
    const title = item.getAttribute('data-title');

    tabItems.forEach(rmItem => {
      rmItem.classList.remove('active');
    });

    item.classList.add('active');

    tabContents.forEach(content => {
      const content_title = content.getAttribute('data-title');
      if (title == content_title) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  });
});

tabContents.forEach(swiper => {
  const productCount = swiper.getAttribute('data-product-count') ? Number(swiper.getAttribute('data-product-count')): 4;
  const swiperItem = new Swiper(swiper, {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: swiper.querySelector('.swiper-button-next'),
      prevEl: swiper.querySelector('.swiper-button-prev')
    },
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 15,
        allowTouchMove: false
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: productCount,
        spaceBetween: 20,
      },
    }
  });

  swipers.push(swiper);
});

window.addEventListener("resize", (event) => {
  if (window.innerWidth > 1024) {

  } else if (window.innerWidth > 768) {

  } else {

  }
});
